<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <h1>User Tracking</h1>
            </v-col>
        </v-row>

        <!-- Freedom Figure -->
        <v-row align="start"
               justify="center"
        >
            <v-col cols="12" sm="10" lg="9" xl="7"
            >
                <v-card>
                    <v-card-title>Freedom Figure</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="ffHeaders"
                                      :items="ffItems"
                                      disable-filtering
                                      disable-sort
                                      disable-pagination
                                      hide-default-footer
                                      class="FreedomFigureTable FreedomFigureTable--alt-shading"
                        >
                            <template v-slot:item.target_income="props">
                                {{ formatDollar(props.item.target_income) }}
                            </template>

                            <template v-slot:item.package_price="props">
                                {{ formatDollar(props.item.package_price) }}
                            </template>

                            <template v-slot:item.close_percentage="props">
                                {{ formatNumber(props.item.close_percentage) }}
                            </template>

                            <template v-slot:item.required_clients>
                                {{ formatNumber(requiredClients) }}
                            </template>

                            <template v-slot:item.monthly_calls>
                                {{ formatNumber(monthlyCalls) }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Monthly Numbers -->
        <v-row align="start"
               justify="center"
        >
            <v-col cols="12" sm="10" lg="9" xl="7"
            >
                <v-card>
                    <v-card-title>Monthly Numbers</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="mnHeaders"
                                      :items="mnItems"
                                      disable-sort
                                      disable-pagination
                                      hide-default-footer
                                      class="FreedomFigureTable"
                        >
                            <template v-slot:item.month="props">
                                {{ translateMonth(props.item.month) }}
                            </template>

                            <template v-slot:item.visits="props">
                                {{ props.item.visits === 0 ? '' : formatNumber(props.item.visits) }}
                            </template>
                            <template v-slot:item.booked_calls="props">
                                {{ props.item.booked_calls === 0 ? '' : formatNumber(props.item.booked_calls) }}
                            </template>
                            <template v-slot:item.held_calls="props">
                                {{ props.item.held_calls === 0 ? '' : formatNumber(props.item.held_calls) }}
                            </template>
                            <template v-slot:item.closed_calls="props">
                                {{ props.item.closed_calls === 0 ? '' : formatNumber(props.item.closed_calls) }}
                            </template>
                            <template v-slot:item.booked_visits="props">
                                {{
                                    formatConversionPercentage(props.item.booked_calls, props.item.visits)
                                }}
                            </template>
                            <template v-slot:item.held_booked="props">
                                {{
                                    formatConversionPercentage(props.item.held_calls, props.item.booked_calls)
                                }}
                            </template>
                            <template v-slot:item.closed_held="props">
                                {{
                                    formatConversionPercentage(props.item.closed_calls, props.item.held_calls)
                                }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import freedomFigureMixin from '@/views/Public/Card/freedomFigureMixin';

export default {
    mixins: [freedomFigureMixin],
    mounted() {
        this.getData();
    },

    data() {
        return {
            loaded: true,
            id: null
        };
    },

    methods: {
        getData() {
            axios.get('/api/freedom-figure/admin/' + this.$router.currentRoute.params.id)
                .then(response => {
                    this.freedomFigure = response.data.data.figure;
                    this.ffItems.push(this.freedomFigure);
                    this.id = this.freedomFigure.id;
                    this.loaded = true;
                })

                .catch(error => {
                    console.error(error);
                    this.loaded = true;
                });

            axios.get('/api/freedom-figure-monthly/admin/' + this.$router.currentRoute.params.id)
                .then(response => {
                    this.monthlyNumbers = response.data.data.numbers;
                    this.mnItems = this.monthlyNumbers;
                    this.loaded = true;
                })

                .catch(error => {
                    console.error(error);
                    this.loaded = true;
                });
        }
    }
};
</script>
